(ns dre.pages.admin.usage.views
  (:require
   ["antd" :refer [Popover Spin]]
   [clojure.string :as str]
   [dre.app.router :as router]
   [dre.components.icon :refer [fa-icon]]
   [dre.components.pill :as pill-component]
   [dre.components.range-picker :refer [range-picker]]
   [dre.components.select :refer [select]]
   [dre.components.switch :refer [switch]]
   [dre.components.icons-iconoir :refer [icoinor-icon antd-pagination-icons]]
   [dre.components.table :refer [table]]
   [dre.components.tabs :refer [tabs]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.events :as-alias modals]
   [dre.pages.admin.usage.events :as usage]
   [dre.pages.admin.views :refer [nav-tabs]]
   [dre.shared.interface.search.blunt :as blunt]
   [dre.utils.bem :as bem]
   [reagent.core :as r]
   [re-frame.core :as rf]))

(def component-name :admin-usage)

(defn- include-dre?
  []
  (let [value @(rf/subscribe [::usage/value-of-filter :include-dre])]
    [:div {:class (bem/be component-name :include-dre)}
     [:div "Include DRE users?"]
     [switch
      {:value value
       :on-change #(rf/dispatch [::usage/on-filter-change :include-dre (not value)])
       :size :small}]]))

(defn- checkbox
  [id label]
  [:div.input-group
   [:input.input {:type :checkbox
                  :id id
                  :checked @(rf/subscribe [::usage/value-of-filter id])
                  :on-change #(rf/dispatch [::usage/on-filter-change id (.. % -target -checked)])}]
   [:label.label {:for id} [tr label]]])

(defn- call-type
  []
  [tooltip-wrapper
   "Include browser calls, API calls, or both"
   [:div {:class (bem/be component-name :call-type)}
    [:div "Types of calls to Include"]
    [:div {:class (bem/be component-name :call-type-checkboxes)}
     [checkbox :include-browser "Browser"]
     [checkbox :include-api "API"]]]])

(defn- search-filters
  []
  [:div
   {:class (bem/be component-name :search-filters)}
   [range-picker
    {:on-change #(rf/dispatch [::usage/on-date-filter-change %])
     :presets :default
     :value [@(rf/subscribe [::usage/value-of-filter :from])
             @(rf/subscribe [::usage/value-of-filter :to])]}]
   [include-dre?]
   [call-type]
   [select
    {:showSearch true
     :allowClear true
     :suffixIcon (r/as-element [icoinor-icon :nav-arrow-down])
     :disabled @(rf/subscribe [::usage/value-of-filter :username])
     :value @(rf/subscribe [::usage/value-of-filter :client])
     :onChange #(rf/dispatch [::usage/on-filter-change :client %])
     :placeholder [tr "Filter by client"]
     :options @(rf/subscribe [::usage/client-list-datasource])}]
   [select
    {:showSearch true
     :allowClear true
     :suffixIcon (r/as-element [icoinor-icon :nav-arrow-down])
     :disabled @(rf/subscribe [::usage/value-of-filter :client])
     :value @(rf/subscribe [::usage/value-of-filter :username])
     :onChange #(rf/dispatch [::usage/on-filter-change :username %])
     :placeholder [tr "Filter by username"]
     :options @(rf/subscribe [::usage/user-list-datasource])}]])

(defn- search-submit
  [state]
  [:div
   {:class (bem/be component-name :search-submit)}
   [:button.button.button--brand
    {:on-click #(rf/dispatch [::router/redirect-to-handler-with-query-params :admin-usage (usage/filters->url state)])}
    [tr "Go!"]]])

(defn- showing-results
  [from to]
  [:div
   {:class (bem/be component-name :showing-results-column)}
   (str from " - " to)])

(defn- events-results
  [result-count]
  [table
   {:title (fn [] (when
                   result-count
                    (r/as-element [:span
                                   (str
                                    result-count
                                    " Results ")
                                   [:button
                                    {:on-click (fn [e] (rf/dispatch [::modals/set-modal :usage/usage @(rf/subscribe [::usage/filters])]))
                                     :class [(bem/bm :button :brand)]}
                                    "Export"]])))
    :columns [{:title [tr "Time"]
               :dataIndex :time}
              {:title [tr "Email"]
               :dataIndex :email}
              {:title [tr "Client"]
               :dataIndex :client}
              {:title [tr "Query"]
               :dataIndex :pills
               :render (fn [{:keys [pills]}]
                         [pill-component/readonly-pills pills nil nil nil {}])}
              {:title [tr "Showing results"]
               :render (fn [{:keys [from to]}]
                         [showing-results from to])}
              {:title [tr "BAQ"]
               :render (fn [{:keys [baq]}]
                         (if baq
                           (let [content [:span
                                          [:p [:b "Topic: "] (:topic baq)]
                                          (doall 
                                           (for [c (:categories baq)]
                                             [:p 
                                              [:b (:type c) " "] 
                                              (if (str/blank? (:blunt c))
                                                "N/A"
                                               [pill-component/readonly-pills (blunt/parse (:blunt c)) nil nil nil {:hide-controls? true}])]))]]
                             [:> Popover
                              {:content (r/as-element content)
                               :trigger :hover}
                              [:> Popover
                               {:content (r/as-element content)
                                :trigger :click}
                               [:span [fa-icon :eye]]]])
                           "-"))}]
    :pagination {:position [:topLeft :bottomLeft] 
                 :total (get-in @(rf/subscribe [::usage/events]) [:response :count]) 
                 :pageSize (get-in @(rf/subscribe [::usage/events]) [:pagination :limit])
                 :defaultPageSize (get-in @(rf/subscribe [::usage/events]) [:pagination :limit])
                 :current (get-in @(rf/subscribe [::usage/events]) [:pagination :current-page]) 
                 :itemRender antd-pagination-icons
                 :onChange (fn [page pageSize]
                             (rf/dispatch [::usage/fetch-report
                                           {:type :events
                                            :endpoint :admin/usage.events 
                                            :updated-pagination {:limit pageSize
                                                                 :offset (* (- page 1) pageSize)
                                                                 :current-page page}}]))}
    :dataSource @(rf/subscribe [::usage/events-datasource])}])

(defn- render-company-column
  [{:keys [client] :as x}]
  [:a
   {:on-click #(rf/dispatch [::usage/filter-by-company x])}
   client])

(defn- top-clients-results
  []
  [table
   {:columns [{:title [tr "Company"]
               :dataIndex :client
               :render render-company-column} ; TODO: filter with user on-click
              {:title [tr "Query Count"]
               :dataIndex :count}]
    :dataSource @(rf/subscribe [::usage/top-clients-datasource])}])

(defn- render-user-column
  [{:keys [username] :as x}]
  [:a
   {:on-click #(rf/dispatch [::usage/filter-by-user x])}
   username])

(defn- top-users-results
  []
  [table
   {:columns [{:title [tr "User"]
               :dataIndex :username
               :render render-user-column} ; TODO: filter with user on-click
              {:title [tr "Query Count"]
               :dataIndex :count}]
    :dataSource @(rf/subscribe [::usage/top-users-datasource])}])

(defn- results-container
  []
  [:div
   {:class (bem/be component-name :results-container)}
   [:div
    {:class (bem/be component-name :results-tabs)}
    [tabs
     {:overwrite-active-id @(rf/subscribe [::usage/selected-tab])
      :on-click #(rf/dispatch [::usage/select-tab (:id %)])
      :items
      [{:id :events
        :label [tr "Events"]
        :content (partial events-results (get-in @(rf/subscribe [::usage/events]) [:response :count]))}
       {:id :top-clients
        :label [tr "Top Companies"]
        :content top-clients-results}
       {:id :top-users
        :label [tr "Top Users"]
        :content top-users-results}]}]]])

(defn view
  []
  (let [state @(rf/subscribe [::usage/state])
        events-state @(rf/subscribe [::usage/events-state])
        top-users-state @(rf/subscribe [::usage/top-users-state])
        top-clients-state @(rf/subscribe [::usage/top-clients-state])]
    [:div
     {:class component-name}
     [:div
      {:class (bem/be component-name :nav)}
      [nav-tabs]]
     [:> Spin
      {:spinning (or 
                  (= (get-in state [:users-list :state]) :loading)
                  (= (get-in state [:client-list :state]) :loading)
                  (= events-state :loading)
                  (= top-users-state :loading)
                  (= top-clients-state :loading))}
      [:div {:class (bem/be component-name :content)}
       [search-filters]
       [search-submit state]
       [results-container]]]]))
